export const PASSCODE_ENDPOINTS = {
  IDENTIFY: '/v2/auth/identify',
  CODE: '/v2/auth/code',
  VERIFY: '/v2/auth/code/verify',
  PASSWORD_LOGIN: '/v2/auth/password/login',
  PASSWORD: '/v2/auth/password',
  PASSWORD_RESET: '/v2/auth/password/reset',
  CONTACT_CODE: '/v2/auth/contact/code',
  CONTACT_VERIFY: '/v2/auth/contact/verify',
  CHANNEL_CODE: '/v2/auth/channel/code',
  CHANNEL_VERIFY: '/v2/auth/channel/verify',
} as const;
